<template>
    <div class="page-loader__spinner" v-if="show">
        <svg viewBox="25 25 50 50">
            <circle cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10" />
        </svg>
    </div>
</template>

<script>
    export default {
        props: {
            show: {default: false}
        }
    }
</script>